export default "__VITE_ASSET__df8040b9__"